import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Login from './pages/Login';
import Register from './pages/Register';
import Home from './pages/Home';
import Newclaim from './pages/Newclaim';
import Reports from './pages/Reports';
import Individual from './pages/Individual';
import Terms from './pages/Terms';
import Users from './pages/Users';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Home />} />
          <Route path="/new-claim" element={<Newclaim />} />
          <Route path="/report" element={<Reports />} />
          <Route path="/individual-report" element={<Individual />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/users" element={<Users />} />

          
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default App;
